import type { BuyInStore } from '#types/buyInStore'
import { skipHydrate } from 'pinia'

export const useBuyInStoreStore = defineStore('buyInStore', () => {
  const auth = useAuthStore()

  const emptyStoreInfo = { storeId: '', storeName: '', storeEmployeeId: '', storeEmployeeName: '' }

  const storeInfo = skipHydrate(
    useSessionStorage<BuyInStore>('buyInStore', { ...emptyStoreInfo })
  )
  const employeeConnected = skipHydrate(computed(() => {
    return storeInfo.value.storeEmployeeId && storeInfo.value.storeId
  }))

  const setStoreInfo = (storeData: BuyInStore) => {
    storeInfo.value = storeData
  }

  const clearSession = () => {
    sessionStorage.removeItem('buyInStore')
    storeInfo.value = { ...emptyStoreInfo }
    auth.logout()
    useRouter().replace({ path: '/associate-login' })
  }

  return {
    employeeConnected,
    storeInfo,
    setStoreInfo,
    clearSession,
  }
})
